(() => {
  const ACCENT_CLASS = 'heading-accent';
  const PATTERN = /\[\[(.+?)\]\]/g;
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'NOSCRIPT', 'CODE', 'PRE', 'INPUT']);
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  const parseRoot = (root) => {
    if (!root || !root.nodeType) return;
    const startNode = root.nodeType === 3 ? root.parentNode : root;
    if (!startNode) return;

    const walker = document.createTreeWalker(startNode, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || node.nodeValue.indexOf('[[') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        let parent = node.parentNode;
        while (parent && parent.nodeType === 1) {
          if (SKIP_TAGS.has(parent.nodeName)) return NodeFilter.FILTER_REJECT;
          if (parent.isContentEditable) return NodeFilter.FILTER_REJECT;
          parent = parent.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const targets = [];
    let current;
    while ((current = walker.nextNode())) targets.push(current);
    if (!targets.length) return;

    targets.forEach((textNode) => {
      const text = textNode.nodeValue;
      PATTERN.lastIndex = 0;
      if (!PATTERN.test(text)) return;
      PATTERN.lastIndex = 0;

      const frag = document.createDocumentFragment();
      let lastIndex = 0;
      let match;
      while ((match = PATTERN.exec(text)) !== null) {
        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }
        const span = document.createElement('span');
        span.className = ACCENT_CLASS;
        span.textContent = match[1];
        frag.appendChild(span);
        lastIndex = PATTERN.lastIndex;
      }
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
  };

  const init = () => {
    parseRoot(document.body);
    document.documentElement.classList.add('rte-accent-parsed');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => parseRoot(event.target));
  document.addEventListener('shopify:section:select', (event) => parseRoot(event.target));
  document.addEventListener('shopify:block:select', (event) => parseRoot(event.target));

  if (isDesignMode) {
    const queue = new Set();
    let scheduled = false;

    const flush = () => {
      scheduled = false;
      const nodes = Array.from(queue);
      queue.clear();
      nodes.forEach((node) => {
        if (node && node.isConnected) parseRoot(node);
      });
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(flush);
    };

    const enqueue = (node) => {
      if (!node) return;
      if (node.nodeType === 1) {
        queue.add(node);
        schedule();
      } else if (node.nodeType === 3 && node.nodeValue && node.nodeValue.indexOf('[[') !== -1) {
        if (node.parentNode) {
          queue.add(node.parentNode);
          schedule();
        }
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(enqueue);
        } else if (mutation.type === 'characterData') {
          enqueue(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
})();
